import {
  Component,
  OnInit
} from '@angular/core';
import {
  Router
} from '@angular/router';
import {
  Observable,
  of,
  Subscription
} from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap,
  catchError
} from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { TabList } from '@shared/components/router-tabset/tab-list';
import { TabNavLinks } from '@shared/components/tab-nav/tab-nav-links';
import { QuestionnaireService } from '@app/shared/services/questionnaire.service';
import { User, IUser } from '@app/shared/models/user';
import { UserSubscriber } from '@app/shared/subscribers/user.subscriber';
import { SharedDataService } from '@app/shared/services/shared-data.service';

@Component({
  selector: 'db-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss']
})

export class GlobalHeaderComponent implements OnInit {
  loggedInUser: string;
  tabList: TabList[];
  navLinks: TabNavLinks[];
  adminNavLinks: TabNavLinks[];
  searching = false;
  searchFailed = false;
  debounceValue: number = 3;
  subscription = new Subscription();
  user: User = new User();

  isMultipleDepartments: boolean = false;

  resultFormatter = (value: any) => value.can || '';

  searchClient = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(600),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term => term.length < this.debounceValue ? [] :
        this.questionnaireService.getClients(term).pipe(
          tap(() => {
            this.searchFailed = false;
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          }))
      ),
      tap(() => this.searching = false)
    )

  constructor(
    private router: Router,
    private _userSubscriber: UserSubscriber,
    private authService: MsalService,
    private sharedDataService: SharedDataService,
    private questionnaireService: QuestionnaireService
  ) { }

  ngOnInit() {
    this.subscription.add(this.subscribeToUser());
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  logout() {
    this.authService.logoutRedirect();
  }

  initializeTabs() {
    this.navLinks = [
      new TabNavLinks(1, 'Home', 'main'),
      new TabNavLinks(2, 'Clients', 'clients')
    ];

    if (this.user?.isUserAdmin(this.user.selectedDepartment || '')) {
      this.adminNavLinks = [
        new TabNavLinks(3, 'Questionnaires', 'questionnaires')
      ];
    } else {
      this.adminNavLinks = [];
    }
  }

  selectedClient(client, searchCan) {
    client.preventDefault();

    this.router.navigate(['clients/', client.item.clientId]);

    searchCan.value = '';
  }

  private isMultipleDepartmentsCheck(user: IUser): boolean {
    return user.departments.length > 1;
  }

  private subscribeToUser(): Subscription {
    return this._userSubscriber.user$.subscribe({
      next: (user: User) => {
        if (user) {
          this.user = user;
          this.sharedDataService.userIsAdmin = !!this.user.isUserAdmin(user.selectedDepartment || '');

          this.isMultipleDepartments = this.isMultipleDepartmentsCheck(this.user);

          this.initializeTabs();
        }
      }
    });
  }

  getFriendlyName(department: string): string {
    return this.user.departments.find(d => d.department === department)?.friendlyName || department;
  }
}
